export const Text = {
  baseStyle: {
    marginBottom: 0,
  },
};
